import { AccountLayout } from '../../layouts';
import { AddPhoneValidationComponent } from '../../components/AddPhoneValidationForm';

export const AddPhoneValidation = () => {
  return (
    <AccountLayout
      contents={<AddPhoneValidationComponent />}
      contentColumns={7}
    />
  );
};
